// List of keys used by the circuit navigator components

export const navigator = {
  offset: Symbol('Navigator prop: view offsets'),
  coeff: Symbol('Navigator prop: zoom coefficients'),
  zoom: Symbol('Navigator prop: zoom levels')
}
